export default __webpack_public_path__ + "static/media/carved_ring.66b1f495.webp";